import { InsightsTotals } from '@shared/api/types';

/**
 * Percentage change from `previous` to `current`, or null where there is no
 * baseline to measure against.
 */
export function getPercentageChange(
  current: number | null | undefined,
  previous: number | null | undefined
): number | null {
  if (current == null || previous == null || previous === 0) return null;
  return ((current - previous) / previous) * 100;
}

/** Previous-year figures in the same units as the current-year totals. */
export type PreviousYearMetrics = {
  emissionsTonnes: number | null;
  emissionsPerKg: number | null;
  spend: number | null;
  emissionsPerSpendUnit: number | null;
};

/** Previous-year values for the four headline metrics, normalised for the cards. */
export function getPreviousYearMetrics(
  previousYear?: InsightsTotals
): PreviousYearMetrics {
  return {
    emissionsTonnes: previousYear?.emissionsTonnes ?? null,
    emissionsPerKg: previousYear?.emissionsPerKg ?? null,
    emissionsPerSpendUnit: previousYear?.emissionsPerSpendUnit ?? null,
    spend: previousYear?.spend != null ? Number(previousYear.spend) : null,
  };
}
